// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3426e52","453":"f8b11386","667":"ac9f16fd"}[chunkId] + ".chunk.js";
};